import { WasPatientImmobilizedConstants } from './wasPatientImmobilized.constants'
import { IWasPatientImmobilizedState, IWasPatientImmobilizedAction } from './wasPatientImmobilized.types'

export const wasPatientImmobilizedPrAssess = {
  immCollar: '',
  immCid: '',
  immLbb: '',
  immKed: '',
  immMast: '',
}

export const wasPatientImmobilizedPrNabc = {
  immobBy: null,
  immobOutcome: null,
}

export const initialWasPatientImmobilizedState: IWasPatientImmobilizedState = {
  ...wasPatientImmobilizedPrAssess,
  ...wasPatientImmobilizedPrNabc,
}

export function wasPatientImmobilizedReducer(
  state: IWasPatientImmobilizedState = initialWasPatientImmobilizedState,
  action: IWasPatientImmobilizedAction
): IWasPatientImmobilizedState {
  switch (action.type) {
    case WasPatientImmobilizedConstants.SET_COLLAR:
      return { ...state, immCollar: action.immCollar }
    case WasPatientImmobilizedConstants.SET_CID:
      return { ...state, immCid: action.immCid }
    case WasPatientImmobilizedConstants.SET_LBB:
      return { ...state, immLbb: action.immLbb }
    case WasPatientImmobilizedConstants.SET_KED:
      return { ...state, immKed: action.immKed }
    case WasPatientImmobilizedConstants.SET_MAST:
      return { ...state, immMast: action.immMast }
    case WasPatientImmobilizedConstants.SET_PERFORMED_BY:
      return { ...state, immobBy: action.immobBy }
    case WasPatientImmobilizedConstants.SET_OUTCOME:
      return { ...state, immobOutcome: action.immobOutcome }
    case WasPatientImmobilizedConstants.RESET_WAS_PATIENT_IMMOBILIED:
      return { ...state, ...initialWasPatientImmobilizedState }
    case WasPatientImmobilizedConstants.SET_WAS_PATIENT_IMMOBILIED:
      return { ...state, ...action.wasPatientImmobilized }
    default:
      return state
  }
}
